import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';

import { sendRequest, triggerEvent, validateEmail } from '../helpers/global.js';

import FlexibleInput from './common/FlexibleInput.js';
import SelectInput from './input/SelectInput';

import '../sass/components/VenueEditView.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
  }
};

class VenueEditView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      errors: {},
      formChanged: false,
      areas: [],
    }
  }

  paramId = () => {
    return this.props.match.params.id;
  }

  componentDidMount = () => {
    if (isNaN(this.paramId())) {
      this.props.history.push('/venues');
      return;
    }
    if (this.paramId() === 'create') {
      this.setState({data: {}, formChanged: false});
    } else {
      this.requestData();
    }
    sendRequest({
      method: 'common_data/areas',
      type: 'GET',
      auth: true,
      success: (data) => {
        this.setState({areas: data});
      },
      error: (data) => {
      }
    });
    triggerEvent('logAmplitude', 'edit listing - view page');
  }

  componentDidUpdate = (prevProps, prevState) => {
    const id = this.props.match.params.id;
    const prevId = prevProps.match.params.id;
    if (id !== prevId) {
      if (id === 'create') {
        this.setState({data: {}, formChanged: false});
      } else {
        this.requestData();
      }
      triggerEvent('logAmplitude', 'edit listing - view page');
    }
  }

  updateWithData = (update) => {
    const data = {};
    Object.keys(update).forEach(key => {
      if (key === 'hours') {
        const groups = [];
        (update[key] || []).forEach(item => {
          let group = groups.find(g =>
            g.started_at === item.started_at && g.ended_at === item.ended_at
          );
          if (group) {
            group.days.push({
              day: item.day,
              id: item.id,
            });
          } else {
            groups.push({
              id: `$${groups.length+1}`,
              days: [{
                day: item.day,
                id: item.id,
              }],
              started_at: item.started_at,
              ended_at: item.ended_at,
            });
          }
        });
        data[key] = groups;
      } else {
        data[key] = update[key];
      }
    });
    this.setState({data, formChanged: false});
  }

  requestData = () => {
    if (!this.paramId() || this.paramId() === 'create') {
      return;
    }
    sendRequest({
      method: `venues/${this.paramId()}`,
      type: 'GET',
      success: (data) => {
        this.updateWithData(data);
      },
      error: (data) => {
      }
    });
  }

  prepareData = () => {
    const data = {};
    Object.keys(this.state.data).forEach(key => {
      if (key === 'images') {
        const value = this.state.data[key] || [];
        data[key] = value.map(i =>
          i.uploaded ? {
            id: i.id,
            image_url: i.uploaded,
          } : {
            id: i.id
          }
        );
      } else if (['menu_url', 'avatar_url'].includes(key)) {
        const value = this.state.data[key];
        if (typeof value === 'object') {
          if (!value || value.removed) {
            data[key] = null;
          } else if (value.uploaded) {
            data[key] = value.uploaded;
          }
        }
      } else if (key === 'hours') {
        const hours = [];
        this.state.data[key].forEach(group => {
          group.days.forEach(day => {
            hours.push({
              id: day.id,
              day: day.day,
              started_at: group.started_at,
              ended_at: group.ended_at,
            })
          });
        });
        data[key] = hours;
      } else {
        data[key] = this.state.data[key];
      }
    });
    return data;
  }

  validateData = (data) => {
    const errors = {};
    ['street', 'building_id', 'country', 'area_ids', 'phone', 'average_price'].forEach(key => {
      if (!data[key]) {
        errors[key] = 'Field is required';
      } else if (data[key].constructor.name === 'Array' && !data[key].length) {
        errors[key] = 'Field is required';
      }
    });
    if (!data['name']) {
      errors['name'] = 'Name of business cannot be empty';
    }
    if (!data['email']) {
      errors['email'] = 'Email cannot be empty';
    } else if (!validateEmail(data['email'])) { 
      errors['email'] = 'Invalid email';
    }
    if (data['zipcode'] && !data['zipcode'].match(/^\d+$/)) {
      errors['zipcode'] = 'Invalid postal code';
    }
    if (data['phone'] && !data['phone'].match(/^\+?\d+$/)) {
      errors['zipcode'] = 'Invalid contact number';
    }
    if (data['bio'].length > 500) {
      errors['bio'] = 'Description should be within 500 characters';
    }
    return errors;
  }

  onSave = () => {
    const data = this.prepareData();
    const errors = this.validateData(data);

    this.setState({errors});
    if (Object.keys(errors).length > 0) {
      return;
    }
    sendRequest({
      method: `venues/${this.paramId() === 'create' ? '' : this.paramId()}`,
      type: this.paramId() === 'create' ? 'POST' : 'PUT',
      data: data,
      success: (data) => {
        this.updateWithData(data);
        if (this.paramId() === 'create') {
          this.props.history.replace(`/venues/${data.id}`);
          triggerEvent('showSnackbar', [{text: 'Outlet created', type: 'success'}]);
          Storage.setData('user', {
            ...this.props.user,
            venues: [
              ...this.props.user.venues,
              data,
            ]
          });
        } else {
          triggerEvent('showSnackbar', [{text: 'Outlet updated', type: 'success'}]);
        }
        triggerEvent('logAmplitude', 'edit listing - success');
      },
      error: (data) => {
        if (data.errors) {
          this.setState({errors: data.errors});
        }
      }
    });
  }

  handleChange = (key, value) => {
    const errors = this.state.errors;
    const data = this.state.data;
    if (key === 'bio' && value.length > 500) {
      errors[key] = true;
    }
    if (key === 'country' && value !== data[key]) {
      data.area_ids = [];
    }
    this.setState({
      data: {
        ...data,
        [key]: value,
      },
      errors,
      formChanged: true,
    })
  }

  renderInputBlock = (key, title, properties) => {
    return (
      <div className='inputBlock'>
        {key === 'bio' ?
          <div
            className={classnames('characterCounter', {
              'error': this.state.errors[key]
            })}
          >{(this.state.data[key] || '').length} / 500</div>
        : null}
        <label>{title}</label>
        <FlexibleInput
          properties={properties}
          object={this.state.data[key]}
          onChange={(k, value) => this.handleChange(key, value)}
          error={this.state.errors[key]}
        />
      </div>
    )
  }

  renderVenueSelect = () => {
    if (this.paramId() === 'create') {
      return null;
    }
    const paramId = Number(this.paramId());
    const venues = this.props.user?.venues || [];
    return (
      <div className='venueBlock'>
        <div className='blockTitle'>Restaurant outlet</div>
        <div className='inputBlock'>
          <label>Outlet</label>
          <SelectInput
            properties={{
              type: 'select',
              options: venues,
            }}
            object={paramId}
            onChange={(k, value) => {
              if (paramId !== value) {
                if (this.state.formChanged) {
                  const venue = venues.find(i => i.id === paramId);
                  triggerEvent('showConfirmation', [{
                    title: 'Unsaved changes',
                    body: `
                      <p>Hey there! It looks like you have some unsaved 
                      changes to ${venue.name}.</p>
                      <p>Are you sure you want to leave this page?</p>
                    </>`,
                    confirmText: 'Leave',
                    cancelText: 'Stay',
                    callback: confirm => {
                      if (confirm) {
                        this.props.history.push(`/venues/${value}`);
                      }
                    }
                  }]);
                } else {
                  this.props.history.push(`/venues/${value}`);
                }
              }
            }}
          />
        </div>
      </div>
    )
  }

  render = () => {
    const data = this.state.data;
    return (
      <div className='venueEditView'>
        <div className='venueTitle'>
          {this.paramId() === 'create' ? 'Add an outlet' : 'Edit listing'}
        </div>
        {this.renderVenueSelect()}
        {data ?
          <div className='venueBlock'>
            <div className='blockTitle'>Basic information</div>
            <div className='doubleBlock'>
              {this.renderInputBlock('name', 'Name of your business*', { type: 'text' })}
            </div>
            <div className='doubleBlock'>
              {this.renderInputBlock('street', 'Street address*', { type: 'text' })}
              {this.renderInputBlock('building_id', 'Mall and unit number*', {
                type: 'select',
                request: 'venues/buildings',
                async: true,
              })}
            </div>
            <div className='doubleBlock'>
              {this.renderInputBlock('zipcode', 'Postal code', { type: 'text' })}
              {this.renderInputBlock('country', 'Country*', {
                type: 'select',
                options: [
                  { id: 'Singapore', name: 'Singapore' },
                  { id: 'Malaysia', name: 'Malaysia' },
                ],
              })}
            </div>
            {this.renderInputBlock('area_ids', 'Neighbourhood*', {
              type: 'multi-select',
              options: this.state.areas.filter(i => i.country === data.country),
            })}
            <div className='blockTitle'>Additional information</div>
            <div className='doubleBlock'>
              {this.renderInputBlock('phone', 'Contact number (for enquires)*', { type: 'text' })}
              {this.renderInputBlock('email', 'Email (for enquires)*', { type: 'text' })}
            </div>
            {this.renderInputBlock('website', 'Website', {
              type: 'text',
              placeholder: 'Optional',
            })}
            {this.renderInputBlock('category_ids', 'Categories', {
              type: 'multi-select',
              request: 'common_data/categories',
              requestAuth: true,
            })}
            {this.renderInputBlock('hours', 'Opening hours', { type: 'opening-hours' })}
            <div className='doubleBlock'>
              {this.renderInputBlock('menu_website', 'URL for online menu', { type: 'text' })}
              {this.renderInputBlock('average_price', 'Estimated cost per pax (SGD)*', { type: 'number' })}
            </div>
            {this.renderInputBlock('menu_url', 'Your menu (PDF max. 10mb)', {
              type: 'file-upload',
              accept: 'application/pdf',
            })}
            {this.renderInputBlock('avatar_url', 'Your business logo', {
              type: 'file-upload',
              accept: 'image/*',
            })}
            {this.renderInputBlock('images', 'Photos of your business', {
              type: 'file-multi-upload',
              accept: 'image/*',
            })}
            {this.renderInputBlock('bio', 'Description', {
              type: 'textarea',
              placeholder: 'Enter a short description of your business',
            })}
            <button
              onClick={this.onSave}
              disabled={!this.state.formChanged}
            >
              {this.paramId() === 'create' ? 'Create' : 'Save Changes'}
            </button>
          </div>
        : null}
      </div>
    )
  }
}

export default connect(mapStoreToProps)(withRouter(VenueEditView));
